export enum Role { 
    Admin = 0,
    PRECISE = 1,
    DxPro = 2,
    VennHealth = 3,
    PREDICT = 4,
    US_COUNTY_FIPS = 5,
    PRECISE_Biomarkers = 6
}

export enum AppRoles {
    PRECISE = 1,
    DxPro = 2,
    VennHealth = 3,
    PREDICT = 4,
    US_COUNTY_FIPS = 5,
    PRECISE_Biomarkers = 6
}

export enum AvailableAppRoles {
    PRECISE = 1001,
    DxPro = 1002,
    VennHealth = 1003,
    PREDICT = 1004,
    US_COUNTY_FIPS = 1005,
    PRECISE_Biomarkers = 1006
}

export enum DemoAppRoles {
    PRECISE_Demo = 101,
    DxPro_Demo = 102,
    VennHealth_Demo = 103,
    PREDICT_Demo = 104,
    US_COUNTY_FIPS_Demo = 105,
    PRECISE_Biomarkers_Demo = 106
}

export class RoleModel {
    id: number;
    name: string
    created: Date;
    updated: Date;
    associations?: number;
}